import { IAssemblyApplicationTypeResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const assemblyApplicationTypesDefaultSort: DataSourceSort[] = [
    { field: 'Name', dir: 'asc' },
];

export type AssemblyApplicationTypesFilter = Readonly<{
    nameSearch?: string;
    active?: boolean;
}>;

export type UseAssemblyApplicationDataSourceOptions = BaseDataSourceOptions<
    IAssemblyApplicationTypeResponse,
    AssemblyApplicationTypesFilter
>;

const getAssemblyApplicationTypes: DataSourceQuery<
    IAssemblyApplicationTypeResponse,
    AssemblyApplicationTypesFilter
> = async ({ filter: { nameSearch, active }, sort, page, pageLimit }) => {
    const filter = Filter.and(
        nameSearch ? Filter.contains('Name', nameSearch) : undefined,
        active !== undefined ? Filter.eq('Active', active) : undefined,
    );
    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAssemblyApplicationTypes({ filter, page, pageLimit, orderBy }),
    );
};

export type AssemblyApplicationTypePagedDataSource = PagedDataSource<
    IAssemblyApplicationTypeResponse,
    AssemblyApplicationTypesFilter
>;

export function usePagedAssemblyApplicationTypeDataSource({
    defaultSort = assemblyApplicationTypesDefaultSort,
    ...options
}: UseAssemblyApplicationDataSourceOptions): AssemblyApplicationTypePagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAssemblyApplicationTypes,
    });
}

export type AssemblyApplicationTypeInfiniteDataSource = InfiniteDataSource<
    IAssemblyApplicationTypeResponse,
    AssemblyApplicationTypesFilter
>;

export function useInfiniteAssemblyApplicationTypesDataSource({
    defaultSort = assemblyApplicationTypesDefaultSort,
    ...options
}: UseAssemblyApplicationDataSourceOptions): AssemblyApplicationTypeInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAssemblyApplicationTypes,
    });
}
